import styled from 'styled-components';

export const Alphabets = styled.ul`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  justify-items: center;
  padding: 0 8px;

  & li {
    width: clamp(30px, 4vw, 42px);
    height: clamp(30px, 4vw, 42px);
    line-height: clamp(27px, 4vw, 39px);
    box-shadow: 0 2px 2px 0 rgba(0, 109, 54, 0.12);
    border: solid 1px rgba(94, 151, 145, 0.4);
    background-color: #fff;
    border-radius: 50%;
    text-align: center;
    color: #5e9791;
    font-size: clamp(13px, 2vw, 13px);
    font-weight: 500;
    margin: 10px 0;
    transition: all 0.1s cubic-bezier(0.6, -0.28, 0.735, 0.045);
    &:nth-last-child(2) {
      grid-column: 3/4;
    }
    &:hover {
      transform: scale(1.09);
    }
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  & .active {
    border: solid 1px #5e9791;
    background-color: #5e9791;
    color: #fff;
  }
`;

export const MainTitle = styled.h1`
  font-size: clamp(18px, 2vw, 24px);
  text-align: center;
  padding: 0 0 20px;
  letter-spacing: 2px;
  color: rgb(0 0 0 / 87%);
`;

export const TitleSemicircle = styled.span`
  display: inline-block;
  width: 12px;
  height: 24px;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: ${(props) =>
    props.unique ? (props.blue ? '#d0effa' : ' #fad0d0') : '#effafc'};
`;

export const ExploreNameTitle = styled.h3`
  font-size: clamp(15px, 2vw, 16px);
  font-weight: 700;
  color: #5e9791;
  text-transform: uppercase;
  padding: 20px 0 6px;
  display: flex;
  align-items: center;

  .titleName {
    padding-left: 6px;
    display: inline-block;
    width: 100%;
    text-align: center;
    letter-spacing: 1.5px;

    @media (max-width: 720px) {
      text-align: left;
    }
  }
`;

export const BrowseLetter = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #f7fcfd;
  margin: 10px 0;
  text-align: center;
  padding-bottom: 14px;
`;

export const BrowseLetterTitle = styled.h6`
  display: inline-block;
  font-weight: 500;
  background-image: linear-gradient(to right, #fff 50%, rgba(255, 255, 255, 0));
  margin: 16px 0;
  padding: 2px 8px;
  font-size: 15px;

  color: rgb(0 0 0 / 67%);
`;
export const View = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 12px 12px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
  background-color: ${(props) => (props.startWith ? 'white' : '#f7fcfd')};
  margin: ${(props) => (props.startWith ? '10px 8px 12px' : '10px 0')};

  cursor: pointer;
  filter: ${(props) => (props.showSaved ? 'none' : 'opacity(0.5)')};

  @media (max-width: 720px) {
    margin: ${(props) => (props.startWith ? '10px 8px 12px' : '10px 16px')};
  }
  & .saved {
    width: 24px;
    height: auto;
    margin: 0 14px 0 0;
    object-fit: contain;
  }
  & .arrow {
    width: auto;
    height: 12px;
    margin-left: auto;
  }
`;

export const ViewImage = styled.img`
  width: 24px;
  height: auto;
  margin: 0 14px 0 0;
  object-fit: contain;
`;
export const ViewSpan = styled.span`
  padding: 1px 40px 1px 0;
  opacity: 0.72;
  font-size: 15px;
  font-weight: bold;
  color: #000;
`;
export const RightArrow = styled.img`
  width: auto;
  height: 12px;
  margin-left: auto;
`;
